import Image from 'next/image'

import Link from '@/atoms/Link/Link'

/* assets */
import TrustedPartnerMob from 'public/assets/customers/images/trusted-partner-mob-bg.png'
import TrustedPartnerMed from 'public/assets/customers/images/trusted-partner-med-bg.png'
import TrustedPartnerDesk from 'public/assets/customers/images/trusted-partner-desk-bg.png'

function TrustedPartner() {
  return (
    <section className="relative font-body text-white">
      <Image
        src={TrustedPartnerMob.src}
        alt=""
        width={TrustedPartnerMob.width}
        height={TrustedPartnerMob.height}
        className="block md:hidden"
      />
      <Image
        src={TrustedPartnerMed.src}
        alt=""
        width={TrustedPartnerMed.width}
        height={TrustedPartnerMed.height}
        className="hidden md:block lg:hidden"
      />
      <Image
        src={TrustedPartnerDesk.src}
        alt=""
        width={TrustedPartnerDesk.width}
        height={TrustedPartnerDesk.height}
        className="hidden lg:block"
      />
      <div className="container text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 | max-w-col-7">
        <div>
          <h1 className="font-heading | text-3xl md:text-4xl text-white font-semibold | mb-2 md:mb-5">
            A trusted partner in 2500+ growth stories
          </h1>

          <p className="text-base | mb-6 md:mb-14">
            Pepper Content has helped 2500+ customers around the world to create
            impactful content that drives revenue and fosters growth
          </p>
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-6">
          {/* TODO: Confirm on the href */}
          <Link
            href="https://business.peppercontent.io/signup"
            target="_self"
            className="font-body | flex-grow | text-center text-xl text-white font-medium | border border-white rounded-lg max-h-14 py-4 px-6"
          >
            Sign Up
          </Link>
          <Link
            href="/book-a-demo/"
            target="_blank"
            className="font-body | flex-grow | text-center text-xl font-medium | new-btn-tertiary"
          >
            Book a Demo
          </Link>
        </div>
      </div>
    </section>
  )
}

export default TrustedPartner
